import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";
import { Label } from "../ui/label";

export const SelectInput = (props) => {
  const {
    description = "",
    label,
    options = [],
    value,
    onChange,
    ...restProps
  } = props;

  return (
    <div className="space-y-2">
      {label ? <Label>{label}</Label> : null}
      <Select value={value} onValueChange={onChange} {...restProps}>
        <SelectTrigger>
          <SelectValue placeholder={label || "Select an option"} />
        </SelectTrigger>
        <SelectContent>
          {options.map(({ label, value }) => {
            return (
              <SelectItem key={value} value={value}>
                {label}
              </SelectItem>
            );
          })}
        </SelectContent>
      </Select>
      {description ? (
        <p className="text-xs text-muted-foreground">{description}</p>
      ) : null}
    </div>
  );
};

export default SelectInput;
